import type { QueryClient } from '@tanstack/react-query';
import { ApprovalEntry } from '../../../api/entries';
import { TimeEntryStatusEnum, TimeEntryStatus } from '../../../types';

// Only these three statuses can ever appear in the approvals queue.
export const QUEUE_STATUSES: TimeEntryStatus[] = [TimeEntryStatusEnum.PENDING_SCRUM, TimeEntryStatusEnum.PENDING_LEAD, TimeEntryStatusEnum.PENDING_MANAGER];

export const ROLE_LABEL: Record<ApprovalEntry['callerRole'], string> = {
  scrum: 'As Scrum Master',
  lead: 'As Project Lead',
  manager: 'As Direct Manager',
};

export const ROLE_COLOR: Record<ApprovalEntry['callerRole'], string> = {
  scrum: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-950/40 dark:text-yellow-400',
  lead: 'bg-orange-100 text-orange-800 dark:bg-orange-950/40 dark:text-orange-400',
  manager: 'bg-blue-100 text-blue-800 dark:bg-blue-950/40 dark:text-blue-400',
};

export function invalidateApprovalsQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ['approvals-queue'] });
  queryClient.invalidateQueries({ queryKey: ['approvals-queue-count'] });
}
